module.exports = __webpack_public_path__ + "static/media/dinderBW.95e7aa83.png";